import { Locale } from '@yi/core';

import { browserNavigate } from './browserNavigate';
import { getLocalizedPath } from './navigation';

const LOGOUT_PAGE_PATH = '/logout';

export const logUserOut = (locale: Locale) => {
  const path = getLocalizedPath(LOGOUT_PAGE_PATH, locale);
  browserNavigate(path);
};
